import { useState } from 'react';

const useBulkDelete = () => {
    const [selecting, setSelecting] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);

    const toggleItem = (item) => {
        setSelectedItems((prev) => (prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]));
    };

    const toggleSelecting = () => {
        setSelecting((prev) => !prev);
        if (selecting) {
            setSelectedItems([]); // Clear selection when toggling off
        }
    };

    return {
        selectedItems,
        toggleItem,
        selecting,
        toggleSelecting,
    };
};

export default useBulkDelete;
